import React from "react";

function HealthIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="26"
      viewBox="0 0 30 26"
      fill="none"
    >
      <path
        d="M13.377 25.2363L2.78906 15.3515C2.54297 15.123 2.30859 14.8769 2.0918 14.6249H7.18945C8.51367 14.6249 9.70898 13.8281 10.2188 12.6035L10.834 11.1269L13.7227 17.5429C13.9453 18.041 14.4316 18.3632 14.9766 18.3691C15.5215 18.3749 16.0195 18.0761 16.2656 17.5898L18.75 12.6152L18.8496 12.8144C19.4062 13.9277 20.543 14.6308 21.7852 14.6308H27.9082C27.6914 14.8828 27.457 15.1289 27.2109 15.3574L16.623 25.2363C16.1836 25.6464 15.6035 25.8749 15 25.8749C14.3965 25.8749 13.8164 25.6464 13.377 25.2363ZM29.5137 11.8124H21.7793C21.6035 11.8124 21.4395 11.7128 21.3574 11.5546L19.998 8.84174C19.7578 8.36714 19.2715 8.06245 18.7383 8.06245C18.2051 8.06245 17.7188 8.36128 17.4785 8.84174L15.0527 13.6933L12.0645 7.01948C11.8359 6.50971 11.3203 6.18159 10.7637 6.19331C10.207 6.20503 9.70312 6.53901 9.48633 7.06049L7.62305 11.5312C7.55273 11.707 7.37695 11.8183 7.18945 11.8183H0.9375C0.785156 11.8183 0.644531 11.8417 0.509766 11.8828C0.175781 10.9453 0 9.94917 0 8.93549V8.59565C0 4.49995 2.95898 1.00776 6.99609 0.333932C9.66797 -0.111381 12.3867 0.761666 14.2969 2.67182L15 3.37495L15.7031 2.67182C17.6133 0.761666 20.332 -0.111381 23.0039 0.333932C27.041 1.00776 30 4.49995 30 8.59565V8.93549C30 9.92573 29.8359 10.8984 29.5137 11.8124Z"
        fill="white"
      />
    </svg>
  );
}

export default HealthIcon;
